import { Button } from '@warp-ds/react';

import styles from './CustomNumberInput.module.css';

export interface CustomNumberInputProps {
    id: string;
    value: number;
    label: string;
    helpText?: string;
    setNumber: (number: number) => void;
    min?: number;
    max?: number;
    disableAdd?: boolean;
    disableSubtract?: boolean;
}

export const CustomNumberInput = ({
    id,
    value,
    label,
    helpText,
    setNumber,
    min,
    max,
    disableAdd,
    disableSubtract,
}: CustomNumberInputProps) => (
    <div className={styles['custom-number-input']}>
        <div className={styles['custom-number-input__label-wrapper']}>
            <label className={styles['custom-number-input__label']} htmlFor={id}>
                {label}
            </label>
            {helpText && <span className={styles['custom-number-input__help-text']}>{helpText}</span>}
        </div>
        <div className={styles['custom-number-input__input-wrapper']}>
            <Button
                className={styles['custom-number-input__input-button']}
                utility
                small
                onClick={() => setNumber(value - 1)}
                aria-label={`fjern ${label}`}
                disabled={disableSubtract}
                aria-controls={`${id}-live`}>
                <w-icon name="Minus" size="small" aria-hidden />
            </Button>
            <input
                readOnly
                tabIndex={-1}
                className={styles['custom-number-input__input-field']}
                id={id}
                data-testid={`custom-number-input-${id}`}
                type="number"
                value={value}
                min={min}
                max={max}
                aria-valuenow={value}
                aria-valuemin={min}
                aria-valuemax={max}
            />
            <Button
                className={styles['custom-number-input__input-button']}
                utility
                small
                onClick={() => setNumber(value + 1)}
                aria-label={`legg til ${label}`}
                disabled={disableAdd}
                aria-controls={`${id}-live`}>
                <w-icon name="Plus" size="small" aria-hidden />
            </Button>
        </div>
        <output id={`${id}-live`} aria-live="polite" className="sr-only">
            {value} {label}
        </output>
    </div>
);
